export const searchString = (a: string, b: string) =>
	a.toLocaleLowerCase().includes(b.toLocaleLowerCase());
